import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { makeNewId } from "common/ids";
import Component from "components/Component";
import CopyButton from "components/common/CopyButton";
import IconButton from "components/common/IconButton";
import { useState } from "react";

const GUIDGenerator = () => {
  const [guid, setGuid] = useState(makeNewId());
  const [jsonMode, setJsonMode] = useState(false);
  const formattedGuid = jsonMode ? `"id": "${guid}",` : guid;

  const refreshGuid = () => {
    setGuid(makeNewId());
    navigator.clipboard.writeText(formattedGuid);
  };

  return (
    <Component
      title={"GUID Generator"}
      options={
        <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
          <Box style={{ flexGrow: "1" }} />
          <Typography
            sx={{ fontFamily: "monospace", color: "lightslategray !important" }}
            textAlign={"center"}
          >
            {formattedGuid}
          </Typography>
          <ToggleButtonGroup
            value={jsonMode ? "JSON" : "Raw"}
            onChange={(e) => setJsonMode(e.currentTarget.value === "JSON")}
            color={"primary"}
            size={"small"}
            exclusive
          >
            <ToggleButton value={"Raw"}>{"Raw"}</ToggleButton>
            <ToggleButton value={"JSON"}>{"JSON"}</ToggleButton>
          </ToggleButtonGroup>
          <IconButton
            scale={"small"}
            icon={RefreshIcon}
            onClick={refreshGuid}
          />
          <CopyButton content={formattedGuid} />
        </Stack>
      }
    />
  );
};

export default GUIDGenerator;
